var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableAlignBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21967 10.2803C8.51256 10.5732 8.98744 10.5732 9.28033 10.2803L12.2803 7.28033C12.5732 6.98744 12.5732 6.51256 12.2803 6.21967C11.9874 5.92678 11.5126 5.92678 11.2197 6.21967L9.5 7.93934L9.5 0.75C9.5 0.335787 9.16421 0 8.75 0C8.33579 0 8 0.335787 8 0.75L8 7.93934L6.28033 6.21967C5.98744 5.92678 5.51256 5.92678 5.21967 6.21967C4.92678 6.51256 4.92678 6.98744 5.21967 7.28033L8.21967 10.2803ZM0.75 12C0.335786 12 0 12.3358 0 12.75C0 13.1642 0.335786 13.5 0.75 13.5L16.7 13.5C17.1142 13.5 17.45 13.1642 17.45 12.75C17.45 12.3358 17.1142 12 16.7 12L0.75 12Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableAlignBottom);
export default __webpack_public_path__ + "static/media/table_align_bottom.7790110e470a75b89cd89a800cbb7ac8.svg";
export { ForwardRef as ReactComponent };